var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.43359V6.56414C14 7.12419 14 7.40421 14.109 7.61812C14.2049 7.80629 14.3578 7.95927 14.546 8.05514C14.7599 8.16413 15.0399 8.16413 15.6 8.16413H19.7305M16 13.1641H8M16 17.1641H8M10 9.16406H8M14 2.16406H8.8C7.11984 2.16406 6.27976 2.16406 5.63803 2.49104C5.07354 2.77866 4.6146 3.2376 4.32698 3.80209C4 4.44383 4 5.28391 4 6.96406V17.3641C4 19.0442 4 19.8843 4.32698 20.526C4.6146 21.0905 5.07354 21.5495 5.63803 21.8371C6.27976 22.1641 7.11984 22.1641 8.8 22.1641H15.2C16.8802 22.1641 17.7202 22.1641 18.362 21.8371C18.9265 21.5495 19.3854 21.0905 19.673 20.526C20 19.8843 20 19.0442 20 17.3641V8.16406L14 2.16406Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudit);
export default __webpack_public_path__ + "static/media/Audit.85878dbcd2a2379235b20c0bcc8baa00.svg";
export { ForwardRef as ReactComponent };